module.exports = __webpack_public_path__ + "static/Native-f389184bee66ae1d0cab5bf52d822ecd.jpg";